<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :selectShow="true"
      :show="false"
      :submitData="submitData"
      @success="onSuccess"
    >
      <select-organs
        v-model="formModel.tatSimpleId"
        :needAll="false"
        :selectValue="formModel.tatSimpleId"
      ></select-organs>
      <el-form-item label="排位等级" prop="level">
        <el-select v-model="formModel.level">
          <el-option
            v-for="item in PlatoonLevel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="会员名称">
        <el-input
          v-model="formModel.userName"
          maxlength="20"
          placeholder="请输入会员名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="会员电话">
        <el-input
          v-model="formModel.phone"
          maxlength="20"
          placeholder="请输入会员电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="直属推荐人姓名">
        <el-input
          v-model="formModel.parentUserName"
          maxlength="20"
          placeholder="请输入直属推荐人姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="直属推荐人手机号">
        <el-input
          v-model="formModel.parentPhone"
          maxlength="20"
          placeholder="请输入直属推荐人手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="分润状态" prop="status">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in PlatoonStatus"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="分润时间">
        <el-date-picker
          v-model="formModel.updateTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="serialNumber"
        min-width="80"
        label="排名"
      ></el-table-column>
      <el-table-column
        prop="level"
        min-width="80"
        label="排位等级"
        :formatter="formatterTableLevel"
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="姓名"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="分润状态"
        min-width="100"
        :formatter="formatterTableStatus"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="parentPhone"
        label="直属推荐人手机号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="parentUserName"
        label="直属推荐人姓名"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="分润时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="profit"
        label="分润金额（元）"
        min-width="130"
        :formatter="formatterTableProfit"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column label="操作" min-width="180" v-if="hasPerm('/tatPublicPlatoonPeople/reissue')">
                <template slot-scope="scope">
                    <el-button type="text" @click="Reissue(scope.row.id)" v-if="scope.row.status == 2">补发</el-button>
                    <p v-else>--</p>
                </template>
            </el-table-column> -->
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import TimeRange from "service/constant/TimeRange";
// 页面数据展示接口
import MarketService from "service/MarketService";
import StatisticsService from "service/StatisticsService";
// 排位等级下拉框接口
import PlatoonLevel from "service/constant/PlatoonLevel";
import Regs from "common/conf/Regs";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "levelpublicplatoon",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
  },
  data() {
    return {
      formModel: {
        level: "1",
        status: "",
        platoonName: "",
        phone: "",
        userName: "",
        parentUserName: "",
        parentPhone: "",
        time: TimeRange.monthRange,
        updateTime: "",
        tatSimpleId: "",
      },
      submitService: MarketService.memLevelPublicPlatoonPeople,
      tableData: [],
      isPage: false,
      page: {},
      PlatoonLevel: PlatoonLevel,
      PlatoonStatus: [],
    };
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      if (
        this.formModel.updateTime == null ||
        this.formModel.updateTime == ""
      ) {
        this.formModel.updateTime = [];
      }
      const params = {
        tatSimpleId: this.formModel.tatSimpleId,
        level: this.formModel.level,
        platoonName: this.formModel.platoonName,
        parentUserName: this.formModel.parentUserName,
        parentPhone: this.formModel.parentPhone,
        phone: this.formModel.phone,
        userName: this.formModel.userName,
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      if (this.formModel.updateTime.length) {
        params.updateStart = this.formModel.updateTime[0];
        params.updateEnd = this.formModel.updateTime[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.page = this.$refs.commonTable.page;

    this.getTypeNames("公排状态", (res) => {
      this.PlatoonStatus = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
  },
  methods: {
    formatterTableLevel(row, column, cellValue, index) {
      let value = "";
      this.PlatoonLevel.forEach((item) => {
        if (item.value == cellValue) {
          value = item.label;
        }
      });
      return value ? value : "--";
    },
    formatterTableStatus(row, column, cellValue, index) {
      let value = "";
      this.PlatoonStatus.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value ? value : "--";
    },
    formatterTableProfit(row, column, cellValue, index) {
      return row.status ? this.toYuan(cellValue) : "--";
    },
    formatterTableDate(row, column, cellValue, index) {
      return row.updateTime ? row.updateTime : row.createTime;
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.onSuccess(res);
          this.isPage = false;
        },
        "信息获取失败"
      );
    },
    doReissue(id) {
      this.doLoad(
        MarketService.reissue,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    Reissue(id) {
      this.showConfirm(`确定对该记录进行补发操作？`)
        .then(() => {
          this.doReissue(id);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/LevelPublicPlatoon.vue